import {
  BlackfairBrand,
  Card,
  Carousel,
  FavoriteButton,
  FeaturedOfferBrand,
  GoodDealBrand,
  InspectedBrand,
  MegafairBrand,
  Text,
} from "../../../elements";
import {
  CalendarIcon,
  Car360Icon,
  OdometerIcon,
  PinIcon,
} from "../../../icons";
import {
  currencyFormatter,
  odometerFormatter,
  truncateFormatter,
} from "../../../support";
import { Badges, type VehicleCardProps } from "../vehicle-card.component";
import styles from "./vehicle-card-desktop.module.css";
import { VehicleCardImageDesktop } from "./vehicle-card-image-desktop.component";

export function VehicleCardDesktop({
  title,
  price,
  badge,
  images,
  noPhoto,
  view360,
  odometer,
  location,
  inspected,
  description,
  year,
  url,
  isFavorite = false,
  onFavoriteClick = () => {},
  onImageRender,
  isGoodDeal,
}: Readonly<VehicleCardProps>) {
  const slides = !images?.length || images.length === 0 ? [noPhoto] : images;

  return (
    <div className={styles.Container}>
      <Card>
        <Card.Head>
          <Carousel>
            {slides?.map((image, index) => (
              <Carousel.Slide key={index}>
                <VehicleCardImageDesktop
                  title={`${title} ${description}`}
                  onImageRender={onImageRender}
                  index={index}
                  src={image!}
                />
              </Carousel.Slide>
            ))}
          </Carousel>

          <FavoriteButton
            isFavorite={isFavorite}
            onFavoriteClick={onFavoriteClick}
            dataQA="card_favoritar"
          />

          {inspected && (
            <div className={styles.FixedBadge} data-qa="tag_vistoriado">
              <InspectedBrand />
            </div>
          )}

          {view360 && (
            <div className={styles.Car360Badge} data-qa="tag_visao360">
              <Car360Icon size={16} viewBox="0 0 16 16" color="#fff" />
              <Text variant="body-semibold-2xsmall" color="#fff">
                360º
              </Text>
            </div>
          )}
        </Card.Head>

        <Card.Body>
          <div className={styles.Body}>
            <div className={styles.BodyContent}>
              <div className={styles.Badge}>
                {badge === Badges.MegaFair && <MegafairBrand />}
                {badge === Badges.BlackFair && <BlackfairBrand />}
                {badge === Badges.Featured && <FeaturedOfferBrand />}
                {isGoodDeal && <GoodDealBrand />}
              </div>
              <div>
                <a
                  className={styles.Link}
                  href={url}
                  target="_blank"
                  rel="nofollow"
                >
                  <Text variant="web-title-medium" color="#2E2D37" as="h2">
                    {title}
                  </Text>
                </a>
                <Text
                  title={description.toLocaleLowerCase()}
                  className={styles.Description}
                  color="#696977"
                  as="h3"
                >
                  {truncateFormatter(description.toLocaleLowerCase(), 63)}
                </Text>
              </div>
              <div className={styles.Cell}>
                <div className={styles.CellItem}>
                  <CalendarIcon color="#696977" size={18} viewBox="0 0 18 18" />
                  <Text color="#696977">{year}</Text>
                </div>
                <div className={styles.CellItem}>
                  <OdometerIcon color="#696977" size={18} viewBox="0 0 18 18" />
                  <Text color="#696977">{odometerFormatter(odometer)}</Text>
                </div>
              </div>

              <div className={styles.BodyItem}>
                <PinIcon size={18} viewBox="0 0 18 18" />
                <Text color="#696977">{location}</Text>
              </div>
              <div className={styles.BodyItem} data-position="bottom">
                <Text variant="body-bold-large" color="#2E2D37">
                  {currencyFormatter(price)}
                </Text>
              </div>
            </div>
            <Card.Button
              href={`${url}?lkid=1446#VerParcelasCardRB`}
              target="_blank"
              tag="a"
              rel="nofollow"
              data-qa="btn_ver_parcelas"
            >
              Ver parcelas
            </Card.Button>
          </div>
        </Card.Body>
      </Card>
    </div>
  );
}
